import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';
import type { ComponentProps } from 'lib/component-props';

export type PlanSearchProps = ComponentProps & {
  fields: PlanSearchFields;
};

export type PlanSearchSarProps = ComponentProps & {
  fields: PlanSearchSARFields;
};

type PlanSearchBaseFields = {
  countyErrorMessage: Field<string>;
  countyLabel: Field<string>;
  disclaimerText: Field<string>;
  fieldsRequiredLabel: Field<string>;
  heading: Field<string>;
  submitLabel: Field<string>;
  zipcodeLabel: Field<string>;
  zipcodeErrorMessage: Field<string>;
  zipcodeInvalidErrorMessage: Field<string>;
};

type PlanSearchFields = PlanSearchBaseFields & {
  counties: string[];
  planType: Item;
  submitLabel: Field<string>;
  currentMemeberLabel: Field<string>;
  yearLabel: Field<string>;
  planYears: string;
  initialYearSelection: number;
};

type PlanSearchSARFields = PlanSearchBaseFields & {
  sarPlans: SarPlans[];
  sarSetup: Item;
  plansErrorMessage: Field<string>;
};

export type SarSetupFields = {
  comparisonPage: Item;
  originalYear: Item;
  planType: Item;
  searchPage: Item;
  upgradeYear: Item;
};

export type SarPlans = {
  name: string;
  id: string;
  counties: string;
  suggestedPlans: string;
  year: string;
};

export type PlanTypeFields = {
  name: Field<string>;
  planOptionsListingPage: Item;
  planSearchPage: Item;
  planDetailPage: Item;
};
